// Copyright (C) 2021 TANNER AG

import gql from "graphql-tag";

export const FullEMobilityTopicFragment = gql`
    fragment FullEMobilityTopicFragment on EMobilityTopic {
        id
        title
        slug
        intro
        order
        active
        thumbnail(locales: [$lang, de]) {
            handle
            fileName
            width
            height
            url
            mimeType
        }
        eMobilityContents {
            order
            title
            content
            table
            quote
            info
            assetWithDescriptions(orderBy: sortIndex_ASC) {
                id
                asset(locales: [$lang, de]) {
                    handle
                    fileName
                    width
                    height
                    url
                    mimeType
                }

                description
                localizedAsset {
                    handle
                    fileName
                    width
                    height
                    url
                    mimeType
                }
            }
            image(locales: [$lang, de]) {
                handle
                fileName
                width
                height
                url
                mimeType
            }
            hotspots(orderBy: sortIndex_ASC) {
                posX
                posY
                headline
                description
            }
            twoColumns
            youTubeLink
        }
        eMobilityChapters(orderBy: order_ASC) {
            id
            slug
            title
            order
            intro
            thumbnail(locales: [$lang, de]) {
                handle
                fileName
                width
                height
                url
                mimeType
            }
        }
    }
`;

export default gql`
    query EMobilityTopic($slug: String!, $lang: Locale!, $stage: Stage!) {
        eMobilityTopic(where: { slug: $slug }, locales: [$lang], stage: $stage) {
            ...FullEMobilityTopicFragment
        }
    }
    ${FullEMobilityTopicFragment}
`;



// WEBPACK FOOTER //
// ./src/queries/eMobilityTopic.js